import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const AnchorBannerWrapper = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq.tablet} {
    margin: 0px 32px;
  }

  ${mq.sp} {
    margin: 0 16px;
  }
`;

export const BannerLazyImage = styled.img`
  width: 100%;
  max-width: 728px;
  // MEMO（kimura）: 角丸8pxにするのが期待値（2023年1月10日時点での情報）
  border-radius: 8px;

  @media (any-hover: hover) {
    :hover {
      cursor: pointer;
    }
  }
`;
